module.exports = __webpack_public_path__ + "img/right-icon-1.6a6ded10.png";